import { useCallback } from 'react';
import { v4 as uuid } from 'uuid';
import BlockProps from '../../../models/BlockProps';
import BlockSNSData from './BlockSNSData';
import { useGetBase64Image } from '../../../hooks/UseGetBase64Image';
import Img from '../../Img';
import config from '../../../config';

const BlockSNS = (props: BlockProps) => {
  const { data, editHandler } = props;

  const blockId = data.id;
  const blockData = data.data as BlockSNSData;
  const { icons } = blockData;

  const handleTitleDeleted = useCallback(() => {
    delete blockData.title;
    editHandler(blockId, blockData);
  }, [blockId, blockData, editHandler]);

  const handleLeftPicDeleted = useCallback(() => {
    delete blockData.leftPic;
    editHandler(blockId, blockData);
  }, [blockId, blockData, editHandler]);

  const handleRightSubTitleDeleted = useCallback(() => {
    delete blockData.rightSubTitle;
    editHandler(blockId, blockData);
  }, [blockId, blockData, editHandler]);

  const handleRightSubTitle2Deleted = useCallback(() => {
    delete blockData.rightSubTitle2;
    editHandler(blockId, blockData);
  }, [blockId, blockData, editHandler]);

  const handleDescriptionDeleted = useCallback(() => {
    delete blockData.description;
    editHandler(blockId, blockData);
  }, [blockId, blockData, editHandler]);

  const handleIconDeleted = useCallback((deleteIndex: number) => {
    blockData.icons = blockData.icons.filter((_, index) => index !== deleteIndex);
    editHandler(blockId, blockData);
  }, [blockId, blockData, editHandler]);

  const handleIconAdded = useCallback(() => {
    blockData.icons.push({ title: 'テキスト', iconUrl: config.defaultImageUrl, id: uuid() });
    editHandler(blockId, blockData);
  }, [blockId, blockData, editHandler]);

  const leftPicBase64 = useGetBase64Image(blockData.leftPic?.value);

  return (
    <div className="section-block" id="section-1001">
      <div className="p-wrapper p-wrapper-sm">
        <div className="p-inner">
          {blockData.title && (
            <div className="row">
              <div className="col-xs-12">
                <div className="p-parts-group mb-4">
                  <div className="p-parts-item" id="parts-001-001">
                    <div className="edit--item" data-bs-toggle="modal" data-bs-target="#textEditorModal" id="section-1001-001-001">
                      <div className="ql-align-center"><strong style={{ fontSize: '24px' }}>SNSブロック</strong></div>
                    </div>
                    <div className="p1-toolbox p1-toolbox-objdelete fade show" id="">
                      <button onClick={handleTitleDeleted} className="btn btn-parts-delete" type="button">
                        <i className="fa-solid fa-xmark" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row">
            {blockData.leftPic && (
              <div className="col-xs-12 col-sm-6">
                <div className="p-parts-group mb-4">
                  <div className="p-parts-item">
                    <div
                      className="edit--item"
                      data-bs-toggle="modal"
                      data-bs-target="#imageEditModal"
                      id="section-1001-002-001"
                    >
                      <div className="p-img">
                        <img
                          className=""
                          src={leftPicBase64}
                          alt=""
                          style={{ objectFit: 'contain' }}
                        />
                      </div>
                      <div className="p1-toolbox p1-toolbox-objdelete fade show" id="">
                        <button onClick={handleLeftPicDeleted} className="btn btn-parts-delete" type="button">
                          <i className="fa-solid fa-xmark" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="col-xs-12 col-sm-6">
              <div className="p-parts-group mb-4">
                {blockData.rightSubTitle && (
                  <div className="p-parts-item">
                    <div
                      className="edit--item"
                      data-bs-toggle="modal"
                      data-bs-target="#textEditorModal"
                      id="section-1001-002-002"
                    >
                      <div className="ql-align-center"><strong style={{ fontSize: '20px' }}>見出し</strong></div>
                    </div>
                    <div className="p1-toolbox p1-toolbox-objdelete fade show" id="">
                      <button onClick={handleRightSubTitleDeleted} className="btn btn-parts-delete" type="button">
                        <i className="fa-solid fa-xmark" />
                      </button>
                    </div>
                  </div>
                )}
                {blockData.rightSubTitle2 && (
                  <div className="p-parts-item mt-3">
                    <div
                      className="edit--item"
                      data-bs-toggle="modal"
                      data-bs-target="#textEditorModal"
                      id="section-1001-002-003"
                    >
                      <div className="ql-align-center"><strong style={{ fontSize: '18px' }}>小見出し</strong></div>
                    </div>
                    <div className="p1-toolbox p1-toolbox-objdelete fade show" id="">
                      <button onClick={handleRightSubTitle2Deleted} className="btn btn-parts-delete" type="button">
                        <i className="fa-solid fa-xmark" />
                      </button>
                    </div>
                  </div>
                )}
                {blockData.description && (
                  <div className="p-parts-item mt-3">
                    <div
                      className="edit--item"
                      data-bs-toggle="modal"
                      data-bs-target="#textEditorModal"
                      id="section-1001-002-004"
                    >
                      <div>ここをクリックして表示したいテキストを入力してください。テキストは「右寄せ」「中央寄せ」「左寄せ」といった整列方向、「太字」「斜体」「下線」「取り消し線」、「文字サイズ」「文字色」「文字の背景色」など細かく編集することができます。</div>
                    </div>
                    <div className="p1-toolbox p1-toolbox-objdelete fade show" id="">
                      <button onClick={handleDescriptionDeleted} className="btn btn-parts-delete" type="button">
                        <i className="fa-solid fa-xmark" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="row align-items-stretch row-gap-4">
            {icons && icons.map((icon, k) => (
              <div className="col-4 col-sm-2">
                <div className="p-parts">
                  <div className="p-parts-item">
                    <div
                      className="edit--item"
                      data-bs-toggle="modal"
                      data-bs-target="#imageEditModal"
                      id="section-1001-003-001"
                    >
                      <div className="p-img">
                        <Img src={icon.iconUrl} alt="" style={{ objectFit: 'contain' }} />
                      </div>
                    </div>
                    <div className="p1-toolbox p1-toolbox-objdelete fade show" id="">
                      <button onClick={() => handleIconDeleted(k)} className="btn btn-parts-delete" type="button">
                        <i className="fa-solid fa-xmark" />
                      </button>
                    </div>
                  </div>
                  <div className="p-parts-item">
                    <div
                      className="edit--item"
                      data-bs-toggle="modal"
                      data-bs-target="#textEditorModal"
                      id="section-1001-003-002"
                    >
                      <div className="ql-align-center"><strong>{icon.title}</strong></div>
                    </div>
                    <div className="p1-toolbox p1-toolbox-objdelete fade show" id="">
                      <button onClick={() => handleIconDeleted(k)} className="btn btn-parts-delete" type="button">
                        <i className="fa-solid fa-xmark" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="col-4 col-sm-2">
              <div className="p-parts-group h-100">
                <div className="p-parts-item h-100" onClick={handleIconAdded}>
                  <div className="edit--item h-100 d-flex justify-content-center align-items-center">
                    <i className="fa-solid fa-plus fa-fw" />
                    追加
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockSNS;
